<template>
    <div>
        <b-form-group>
            <label for="input-nom"><strong>Nom de naissance*</strong></label>
            <b-form-input
            id="input-nom-naissance"
            v-model="nomNaissance"
            :state="nomNaissanceState"
            lazy-formatter
            :formatter="upperCase"
            maxlength="50"
            trim
            ></b-form-input>

            <b-form-invalid-feedback :state="nomNaissanceState">
                Veuillez saisir un nom de naissance valide
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
            <label for="input-nom-usage">Nom d'usage</label>
            <b-form-input
            id="input-nom-usage"
            v-model="nomUsage"
            :state="nomUsageState"
            lazy-formatter
            :formatter="upperCase"
            placeholder="Entrez votre nom d'usage le cas échéant"
            maxlength="50"
            trim
            ></b-form-input>

            <b-form-invalid-feedback :state="nomUsageState">
                Veuillez saisir un nom d'usage valide
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="mb-5">
            <label for="input-prenom"><strong>Prénom*</strong></label>
            <b-form-input
            id="input-prenom"
            v-model="prenom"
            :state="prenomState"
            lazy-formatter
            :formatter="upperCase"
            maxlength="50"
            trim
            ></b-form-input>

            <b-form-invalid-feedback :state="prenomState">
                Veuillez saisir un prénom valide
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
            <label for="input-date-naissance"><strong>Date de naissance*</strong></label>
            <b-form-datepicker
            id="input-date-naissance"
            v-model="dateNaissance"
            :state="dateNaissanceState"
            :show-decade-nav="true"
            :hide-header="true"
            :initial-date="initDateNaissance()"
            label-no-date-selected="Sélectionnez une date"
            label-help=""
            ></b-form-datepicker>
        </b-form-group>

        <b-alert show v-if="moins55Ans" variant="warning">
            <b-row align-v="center">
            <b-col cols="auto">
                <b-icon icon="info-circle" scale="1.5"></b-icon>
            </b-col>
            <b-col>
                Etant âgé(e) de moins de 55 ans, veuillez-vous assurer de percevoir une retraite du régime général ou d'un régime intégré au régime général.
            </b-col>
            </b-row>
        </b-alert>

        <b-form-group class="mb-5">
            <label for="input-lieu-naissance"><strong>Lieu de naissance*</strong></label>
            <b-form-input
                id="input-lieu-naissance"
                v-model="lieuNaissance"
                debounce="800"
                :state="lieuNaissanceState"
                @keydown="tappingLieuNaissance"
                @focus="focusingLieuNaissance"
                @blur="bluringLieuNaissance"
                maxlength="300"
                trim
            ></b-form-input>
            <MenuListe
                ref="menuListe"
                :liste="lieuxNaissance"
                @clickOnMenuListe="setLieuNaissance"/>

            <b-form-invalid-feedback :state="lieuNaissanceState">
                Veuillez renseigner votre lieu de naissance
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
            <label for="input-nni"><strong>N° de sécurité sociale*</strong></label>
            <b-form-row>
                <b-col cols="10">
                    <b-form-input
                        id="input-nni"
                        v-model="nni"
                        :state="nniState"
                        lazy-formatter
                        :formatter="upperCase"
                        placeholder="Entrez votre n° à 13 chiffres"
                        maxlength="13"
                        trim
                    ></b-form-input>
                </b-col>

                <b-col>
                    <b-form-input readonly
                        id="input-cleNni"
                        v-model="cleNni"
                        :state="cleNniState"
                        placeholder="Clé"
                        trim
                    ></b-form-input>
                </b-col>
            </b-form-row>

            <b-form-invalid-feedback :state="nniState">
                <div v-if="controlNni() && !controlEqualBirthYear()">Votre n° de sécurité sociale semble incohérent avec votre date de naissance</div>
                <div v-else>Veuillez renseigner un n° de sécurité sociale valide</div>
            </b-form-invalid-feedback>

            <b-alert show v-if="affiliation > 0" variant="warning" class="mt-3 mb-0">
                <b-row align-v="center">
                    <b-col cols="auto">
                        <b-icon icon="info-circle" scale="1.5"></b-icon>
                    </b-col>
                    <b-col v-if="affiliation == 1">
                        Vous êtes actuellement affilié au CNAREFE ; pour toute question nous vous invitons à nous contacter par votre compte AMELI ou par téléphone au <strong>(+33)1.84.90.10.05</strong>
                    </b-col>
                    <b-col v-if="affiliation == 2">
                        Si vous êtes actuellement adhérent à la CFE "contrat RetraitExpat", nous vous invitons à vous rapprocher de cet organisme pour la prise en charge de vos soins. Si vous êtes radié de la CFE, un certificat de radiation vous sera demandé, si besoin, lors de l'instruction de votre dossier.
                    </b-col>
                </b-row>
            </b-alert>
        </b-form-group>

        <b-form-group>
            <label for="select-nationalite"><strong>Nationalité*</strong></label>
            <b-form-select
                id="select-nationalite"
                v-model="nationalite"
                :options="listeNationalites"
                :state="nationaliteState"></b-form-select>

            <b-form-invalid-feedback :state="nationaliteState">
                Veuillez sélectionner votre nationalité dans la liste
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
            <div class="row">
                <div class="col-8">
                    <strong>Avez-vous une Carte Vitale* ?</strong>
                </div>
                <div class="col-4 text-right">
                    <b-form-radio-group
                        id="btn-carte-vitale"
                        v-model="carteVitale"
                        :options="carteVitaleOptions"
                        name="carte-vitale"
                    ></b-form-radio-group>
                </div>
            </div>
        </b-form-group>

        <BackNext
            :buttons="buttons"/>
    </div>
</template>

<script>
import MenuListe from '@/components/MenuListe'
import BackNext from '@/components/BackNext'

export default {
  name: 'Identite',
  components: {
    MenuListe,
    BackNext
  },
  data() {
    return {
        listeNationalites: [],
        carteVitaleOptions: [
            { text: 'Oui', value: 1 },
            { text: 'Non', value: 0 }
        ],
    }
  },
  computed: {
        nomNaissance: {
            get() {
                return this.$store.nomNaissance
            },
            set(val) {
                this.$store.nomNaissance = val
            }
        },
        nomNaissanceState: {
            get() {
                return this.$store.nomNaissanceState
            },
            set(val) {
                this.$store.nomNaissanceState = val
            }
        },
        nomUsage: {
            get() {
                return this.$store.nomUsage
            },
            set(val) {
                this.$store.nomUsage = val
            }
        },
        nomUsageState: {
            get() {
                return this.$store.nomUsageState
            },
            set(val) {
                this.$store.nomUsageState = val
            }
        },
        prenom: {
            get() {
                return this.$store.prenom
            },
            set(val) {
                this.$store.prenom = val
            }
        },
        prenomState: {
            get() {
                return this.$store.prenomState
            },
            set(val) {
                this.$store.prenomState = val
            }
        },
        dateNaissance: {
            get() {
                return this.$store.dateNaissance
            },
            set(val) {
                this.$store.dateNaissance = val
            }
        },
        dateNaissanceState: {
            get() {
                return this.$store.dateNaissanceState
            },
            set(val) {
                this.$store.dateNaissanceState = val
            }
        },
        moins55Ans: {
            get() {
                return this.$store.moins55Ans
            },
            set(val) {
                this.$store.moins55Ans = val
            }
        },
        lieuNaissance: {
            get() {
                return this.$store.lieuNaissance
            },
            set(val) {
                this.$store.lieuNaissance = val
            }
        },
        lieuNaissanceState: {
            get() {
                return this.$store.lieuNaissanceState
            },
            set(val) {
                this.$store.lieuNaissanceState = val
            }
        },
        lieuxNaissance: {
            get() {
                return this.$store.lieuxNaissance
            },
            set(val) {
                this.$store.lieuxNaissance = val
            }
        },
        nni: {
            get() {
                return this.$store.nni
            },
            set(val) {
                this.$store.nni = val
            }
        },
        nniState: {
            get() {
                return this.$store.nniState
            },
            set(val) {
                this.$store.nniState = val
            }
        },
        cleNni: {
            get() {
                return this.$store.cleNni
            },
            set(val) {
                this.$store.cleNni = val
            }
        },
        cleNniState: {
            get() {
                return this.$store.cleNniState
            },
            set(val) {
                this.$store.cleNniState = val
            }
        },
        affiliation: {
            get() {
                return this.$store.affiliation
            },
            set(val) {
                this.$store.affiliation = val
            }
        },
        nationalite: {
            get() {
                return this.$store.nationalite
            },
            set(val) {
                this.$store.nationalite = val
            }
        },
        nationaliteState: {
            get() {
                return this.$store.nationaliteState
            },
            set(val) {
                this.$store.nationaliteState = val
            }
        },
        carteVitale: {
            get() {
                return this.$store.carteVitale
            },
            set(val) {
                this.$store.carteVitale = val
            }
        },
        buttons: function() {
            return {
                routes: {
                    back: 'Accueil',
                    next: 'Coordonnees'
                },
                next: this.$actions.getStepChecked('accueil') && this.$actions.getStepChecked('identite')
            }
        },
        checkAll: function() {
            return (this.nomNaissanceState &&
                    (this.nomUsageState == null || this.nomUsageState) &&
                    this.prenomState &&
                    this.dateNaissanceState &&
                    this.lieuNaissanceState &&
                    this.nniState &&
                    this.nationaliteState &&
                    this.carteVitale != null) ? true : false;
        }
  },
  mounted() {

    // Renvoi vers l'URL du site
    if (this.$store.endOfInscription || !this.$actions.getStepChecked('accueil')) {
        window.location = this.$config.SITE
    }

    // Envoi un évenement onSetStepper pour mettre a jour l'étape
    this.$emit('onSetStepper', 'identite');

    // Construit la liste des nationalités à présenter dans le menu déroulant
    this.$axios
        .get(this.$config.API + '/nationalites', {
            headers: {
                'Authorization': this.$store.token
            }
        })
        .then(response => {
            this.listeNationalites = [{
                value: null,
                text: 'Sélectionnez votre nationalité'
            }];
            response.data.forEach(obj => {
                let item = { value: obj.codepays, text: obj.libelle }
                this.listeNationalites.push(item)
            });
        });
  },
  methods: {
    // Présente une date de naissance dans le module par défaut
    initDateNaissance() {
        const now = new Date()
        return new Date((now.getFullYear() - 60), now.getMonth(), now.getDate())
    },

    // -- Methodes du MenuListe
    tappingLieuNaissance() {
        this.$refs.menuListe.search();
    },
    focusingLieuNaissance() {
        if (this.lieuNaissance != null && this.lieuNaissance.length > 0) {
            this.$refs.menuListe.show();
        } else {
            this.$refs.menuListe.hide();
        }
    },
    bluringLieuNaissance() {
        this.$refs.menuListe.hide();
        this.lieuNaissanceState = (this.lieuNaissance != null && this.lieuNaissance != '') ? true : false;
    },
    getLieuxNaissance() {
        this.$axios
            .get(this.$config.API_NOMINATIM, {
                params: {
                    q: this.lieuNaissance,
                    addressdetails: 1,
                    format: 'geocodejson',
                    limit: 10
                }
            }).then(res => {
                this.lieuxNaissance = [];
                for (let i in res.data.features) {
                    //console.log(res.data.features[i].properties.geocoding)
                    let geocoding = res.data.features[i].properties.geocoding;
                    this.lieuxNaissance.push( { text: geocoding.label, value: geocoding.country } );
                }
                // Affiche le MenuListe avec les résultats ou rien, selon la réponse obtenue
                if (this.lieuxNaissance.length > 0) {
                    this.$refs.menuListe.show();
                } else {
                    this.$refs.menuListe.hide();
                }
            }).catch(function(e) {
                console.log("Error: " + e)
            })
    },
    setLieuNaissance(elt) {
        this.lieuNaissance = elt.text;
        this.$refs.menuListe.hide();
    },
    // -- Fin Methodes du MenuListe

    // Test le format nni incluant les numéros Corses 2A et 2B
    controlNni() {
        return this.nni && this.nni.match(/^[0-9]{5}(\d{2}|2A|2B)[0-9]{6}$/gi) ? true : false
    },

    // Controle si l'assuré a moins de 55 ans
    controlMoins55Ans() {
        // Si une date est renseignée
        if (this.dateNaissance) {
            let birthday = new Date(this.dateNaissance);
            let diff = Date.now() - birthday.getTime();
            let age = new Date(diff);
            // La personne a moins de 55 ans
            if (Math.abs(age.getUTCFullYear() - 1970) < 55) {
                return true
            // Elle a plus de 55 ans
            } else {
                return false
            }
        }
        return null;
    },

    // Test si la date de naissance et l'année du NIR sont équivalentes
    controlEqualBirthYear() {
        var regExp1 = /^\d{2}(\d{2})/;
        var regExp2 = /^\d{1}(\d{2})/;
        if (this.dateNaissance && this.dateNaissance.match(regExp1) && this.nni && this.nni.match(regExp2) && this.controlNni()) {
            if (this.dateNaissance.match(regExp1)[1] == this.nni.match(regExp2)[1]) {
                return true
            }
            return false
        }
        return null
    },

    // Met en forme les nom/prenom en majuscule
    upperCase(value) {
        return value.toUpperCase()
    }

  },
  watch: {
    nomNaissance: function() {
        this.nomNaissanceState = (this.nomNaissance != '' && this.$actions.controlName(this.nomNaissance)) ? true : false
    },
    nomUsage: function() {
        this.nomUsageState = false;
        if (this.nomUsage != '' && this.$actions.controlName(this.nomUsage)) {
            this.nomUsageState = true;
        } else if (this.nomUsage == '') {
            this.nomUsageState = null;
        }
    },
    prenom: function() {
        this.prenomState = (this.prenom != '' && this.$actions.controlName(this.prenom)) ? true : false
    },
    dateNaissance: function() {
        this.dateNaissanceState = this.dateNaissance != '' ? true : false
        // Si un nni est renseigné, alors on controle que les 2 années sont bien égales
        if (this.nni != null && this.controlNni()) {
            // Met a jour dans ce cas le même statut pour les 2 champs
            this.dateNaissanceState = this.nniState = this.cleNniState = this.controlEqualBirthYear();
        }
        // A t il moins de 55 ans ?
        this.moins55Ans = this.controlMoins55Ans()
    },
    lieuNaissance: function() {
        // Lit la variable show du composant enfant menuListe
        if (this.$refs.menuListe.$data.states.show) {
            this.getLieuxNaissance();
        }
    },
    nni: function() {
        // Test le format nni
        this.nniState = this.cleNniState = this.controlNni();
        // Si une dateNaissance est renseignée, alors on controle que les 2 années sont bien égales
        if (this.nniState && this.dateNaissance != null) {
            // Met a jour dans ce cas le même statut pour les 2 champs
            this.nniState = this.cleNniState = this.dateNaissanceState = this.controlEqualBirthYear();
        }

        // Calcul la clé du nni si ce dernier est au bon format
        this.cleNni = '';

        // Le format du nni est OK
        if (this.controlNni()) {
            var c, cs = 0;
            var t = new Array();
            for (var i = 0; i < 13; i++) {
                t[i] = this.nni.substr(i, 1);
                // pour les Corses
                if (t[i].toUpperCase() == 'A') {
                    t[i] = '1';
                } else if (t[i].toUpperCase() == 'B') {
                    t[i] = '2';
                }
                cs += t[i];
            }
            c = parseInt(cs);
            c = c / 97;
            c = 97 - (Math.round((c - parseInt(c)) * 97));

            this.cleNni = c;

            // Lance une requete afin de tester si le nni est déjà renseigné au CNAREFE ou a la CFE
            this.$axios
                // Controle si le NNI fait partie des assurés CNAREFE ou CFE
                // Retourne 0 si inconnu, 1 si CNAREFE, 2 si CFE
                .get(this.$config.API + '/controler-affiliation/' + this.nni, {
                    headers: {
                        'Authorization': this.$store.token
                    }
                })
                .then(response => {
                    this.affiliation = response.data.resultat
                });
        }
    },
    nationalite: function() {
        this.nationaliteState = (this.nationalite) ? true : false;
    },
    // Set l'état de controle général de la page dès lors que checkAll changera d'état
    checkAll: function(val) {
        this.$actions.setStepChecked('identite', val);
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Identite.vue